import React from 'react';

import { fade } from '@material-ui/core/styles';
import styled from '@material-ui/core/styles/styled';
import addMonths from 'date-fns/addMonths';
import differenceInCalendarDays from 'date-fns/differenceInCalendarDays';
import format from 'date-fns/format';
import subMonths from 'date-fns/subMonths';
import DayPicker from 'react-day-picker';
import 'react-day-picker/lib/style.css';

import ChevronLeftIcon from '../../../../../../assets/icons/ChevronLeftIcon';
import ChevronRightIcon from '../../../../../../assets/icons/ChevronRightIcon';
import { CardButton } from '../../../../../../components/UI/CardButton';
import { colorsPalette } from '../../../../../../theme';
import { useStyles } from './styles';

const StyledPicker = ({
  start,
  end,
  startHandler,
  endHandler,
  currentMonth,
  currentMonthHandler,
}) => {
  const classes = useStyles();

  const changeCurrentMonth = (date, isNext) => {
    if (isNext) {
      currentMonthHandler(addMonths(date, 1));
    } else {
      currentMonthHandler(subMonths(date, 1));
    }
  };

  const modifiers = { start, end };

  const handleDayClick = (day) => {
    if (start && !end && differenceInCalendarDays(day, start) === 0) {
      startHandler(undefined);
      return;
    }

    if (start && differenceInCalendarDays(day, start) < 0) {
      startHandler(day);
      endHandler(undefined);
      return;
    }

    if (start && end) {
      startHandler(day);
      endHandler(undefined);
      return;
    }

    if (!start) {
      startHandler(day);
    } else {
      endHandler(day);
    }
  };

  return (
    <DayPicker
      month={currentMonth}
      className={classes.pickerWrapper}
      selectedDays={{ from: start, to: end }}
      numberOfMonths={1}
      modifiers={modifiers}
      onDayClick={handleDayClick}
      fixedWeeks
      disabledDays={[{ after: new Date() }]}
      captionElement={({ date }) => {
        return (
          <Controls>
            <CardButton
              handleClick={() => changeCurrentMonth(date, false)}
              buttonClass={classes.navigationButton}
            >
              <ChevronLeftIcon />
            </CardButton>
            <DateLabel>{format(date, 'MMMM yyyy')}</DateLabel>
            <CardButton
              handleClick={() => changeCurrentMonth(date, true)}
              buttonClass={classes.navigationButton}
            >
              <ChevronRightIcon />
            </CardButton>
          </Controls>
        );
      }}
      navbarElement={() => null}
    />
  );
};

export default StyledPicker;

const DateLabel = styled('span')({
  fontSize: 18,
  textShadow: '0px 4px 4px ' + fade(colorsPalette.blackPure, 0.25),
});
const Controls = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '8px 8px 20px',
});
